module.exports = "/images/hub.png?0f735b78c86e53afca421b4f2c933f86";